import { render, staticRenderFns } from "./ViqRelatedContent.vue?vue&type=template&id=6dff43e0&scoped=true"
import script from "./ViqRelatedContent.vue?vue&type=script&lang=js"
export * from "./ViqRelatedContent.vue?vue&type=script&lang=js"
import style0 from "./ViqRelatedContent.vue?vue&type=style&index=0&id=6dff43e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff43e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dff43e0')) {
      api.createRecord('6dff43e0', component.options)
    } else {
      api.reload('6dff43e0', component.options)
    }
    module.hot.accept("./ViqRelatedContent.vue?vue&type=template&id=6dff43e0&scoped=true", function () {
      api.rerender('6dff43e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqRelatedContent.vue"
export default component.exports